import { Controller } from '@hotwired/stimulus'
import { hideElement, showElement } from "utils/toggle_element_visibility"

export default class extends Controller {
  static targets = [
    "form",
    "successContainer"
  ]

  showSuccessContainer () {
    showElement(this.successContainerTarget)
  }
}
